import owd from 'owd/owd';

export default class FullpageSection extends owd.Component {
	init() {
        this.isCurrent = false;
        this.$element.data('fullpageSectionApi', this);
        this.scrollbarPlaceholder = this.app.getModule('scrollbarPlaceholder');

        if (window.matchMedia('(min-width: 767px)').matches) {
            this.fix100vh();
        }

        this.$element.find('[data-inview]').each((index, item) => {
            const delay = $(item).data('inview-delay');

            $(item).data('inview-timeout', setTimeout(() => {
                $(item).removeData('inview-timeout');
                $(item).addClass('inview-visible');
            }, delay));
        });

        this.bind();
    }

    bind() {

        this.on('resize domready', this.dom.$window, () => {
            if (window.matchMedia('(min-width: 767px)').matches) {
                this.fix100vh();
            }
        });

        this.on('ajaxload pageInEnd imageload', this.dom.$window, () => {
            if (window.matchMedia('(min-width: 767px)').matches) {
                if (this.$inner !== undefined) {
                    this.contentHeight = this.$inner.outerHeight();
                } 
                this.sectionHeight = this.$element.height();
                this.checkScroll();
            }
        });
    }

    fix100vh() {

        this.$element.css({
            height: this.dom.$window.height(),
            minHeight: this.dom.$window.height()
        });

        this.dom.$window.trigger('fp-recalc');

        if (this.$inner !== undefined) {
            this.contentHeight = this.$inner.outerHeight();
        } 
        this.sectionHeight = this.$element.height();
        this.checkScroll();
    }

    in(direction, options) {
        this.isCurrent = true;

        if (this.openHeader) {
            $('[data-menu-toggle]').data('menuToggleApi').show(true);
        }

        this.$element.find('[data-inview]').each((index, item) => {
            const delay = $(item).data('inview-delay');

            $(item).data('inview-timeout', setTimeout(() => {
                $(item).removeData('inview-timeout');
                $(item).addClass('inview-visible');
            }, delay));
        });

        if (this.$filters !== undefined && !this.$filters.is(':visible')) {
            this.$filters.stop().css({
                display: 'block',
                opacity: 0
            }).transition({
                opacity: 1
            }, 500, 'easeOutQuad');
        }

        if (this.isScrollable) {
            if (this.allowScrollTimeout !== undefined) {
                clearTimeout(this.allowScrollTimeout);
                this.allowScrollTimeout = undefined;
            }

            this.allowScrollTimeout = setTimeout(() => {
                this.allowScrollTimeout = undefined;
                this.unlockScroll();
            }, 600);

            if (this.isOverflown()) {
                if (direction == -1) {
                    this.scrollTop = this.getScrollEnd();
                } else {
                    this.scrollTop = this.getScrollStart();
                }

                this.$inner.css({
                    willChange: 'transform'
                });

                this.updateScrolledPosition(true);

                this.scrollbarPlaceholder
                        .setLength(this.contentHeight)
                        .setScroll(this.scrollTop);
            }
        } else {
            this.scrollbarPlaceholder.clear();
        }

        return new Promise((resolve, reject) => {
            this.checkScroll();
            setTimeout(resolve);
        });
    }

    between(direction, options) {

        let filtersDelay = 350;
        if (direction == -1) {
            filtersDelay = 0;
        }

        if (this.$filters !== undefined) {
            this.$filters.stop().css({
                display: 'block',
                opacity: 0
            }).delay(filtersDelay).transition({
                opacity: 1
            }, 250, 'ease');
        }

        if (this.isScrollable && this.isOverflown()) {
            if (direction == -1) {
                this.scrollTop = this.getScrollEnd();
            } else {
                this.scrollTop = this.getScrollStart();
            }

            this.$inner.css({
                willChange: 'transform'
            });

            this.updateScrolledPosition(true);
        }

        this.$element.find('[data-inview]').each((index, item) => {
            $(item).removeClass('inview-visible');
        });

        return new Promise((resolve, reject) => {
            setTimeout(resolve);
        });
    }

    out(direction, options) {
        this.isCurrent = false;

        if (this.openHeader) {
            $('[data-menu-toggle]').data('menuToggleApi').hide(true);
        }

        this.$element.find('[data-inview]').each((index, item) => {
            if ($(item).data('inview-timeout')) {
                clearTimeout($(item).data('inview-timeout'));
                $(item).removeData('inview-timeout');
            }

            $(item).removeClass('inview-visible').addClass('inview-out');
        });

        if (this.$filters !== undefined) {
            this.$filters.stop().transition({
                opacity: 0
            }, 200, 'easeOutQuad', () => {
                this.$filters.css({
                    display: 'none',
                    opacity: 0
                });
            });
        }

        if (this.isScrollable) {
            this.allowScroll = false;
            this.scrollbarPlaceholder.disableScroll();

            if (this.allowScrollTimeout !== undefined) {
                clearTimeout(this.allowScrollTimeout);
                this.allowScrollTimeout = undefined;
            }

            this.scrollbarPlaceholder.clear();
            this.$inner.css({
                willChange: ''
            });
        }
        
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                this.$element.find('[data-inview]')
                    .removeClass('inview-out');

                resolve();

            }, this.$element.data('fullpage-section-duration-out'));
        });
    }

    reset(direction, options) {

    }

    updateScrolledPosition(force) {
        if (this.scrollbarPlaceholder.isAvailable()) {
            // this.$inner.css({
            //     y: this.scrollTop * -1
            // });
        } else if (force === true) {
            this.$element.scrollTop(this.scrollTop);
        }
    }

    checkScroll(dir) {
        if (this.isCurrent) {
            if (this.isScrollable && this.isOverflown()) {
                this.syncScrollbar();

                if (this.enableTimeout !== undefined) {
                    clearTimeout(this.enableTimeout);
                    this.enableTimeout = undefined;
                }

                if (this.isScrolledToStart()) {
                    if (dir == -1) {
                        this.showSectionAbove();
                    }

                    this.enableTimeout = setTimeout(() => {
                        this.app.getModule('fullpage').enableUp();
                        this.enableTimeout = undefined;
                    }, 1000);
                } else {
                    this.app.getModule('fullpage').disableUp();
                }
                
                if (this.isScrolledToEnd()) {
                    if (dir == 1) {
                        this.showSectionBelow();
                    }

                    this.enableTimeout = setTimeout(() => {
                        this.app.getModule('fullpage').enableDown();
                        this.enableTimeout = undefined;
                    }, 1000);
                } else {
                    this.app.getModule('fullpage').disableDown();
                }
                
            } else {
                this.app.getModule('fullpage').enableUp();
                this.app.getModule('fullpage').enableDown();
            }
        }
    }

    showSectionAbove() {
        const $prev = this.$element.prev();
        
        this.showSectionTeaser($prev, 1);
        this.showSectionTeaser(this.$element, 1);
        this.showSectionTeaser($('.header'), 1);
        this.showSectionTeaser($('.filters'), 1);
    }

    showSectionBelow() {
        const $next = this.$element.next();
        
        this.showSectionTeaser($next, -1);
        this.showSectionTeaser(this.$element, -1);
    }

    showSectionTeaser($section, direction) {
        anime({
            targets: $section[0],
            translateY: [0, 25 * direction],
            duration: 400,
            easing: 'easeOutCirc'
        }).finished.then(() => {
            return anime({
                targets: $section[0],
                translateY: [25 * direction, 0],
                duration: 400,
                easing: 'easeInOutCirc'
            }).finished;
        }).then(() => {
            // $section.css({
            //     y: ''
            // });
        });
    }

    isOverflown() {
        return this.contentHeight > this.sectionHeight;
    }

    getScrollStart() {
        return 0;
    }

    getScrollEnd() {
        return Math.max(0, Math.round(this.contentHeight - this.sectionHeight));
    }

    isScrolledToStart() {
        return this.scrollTop === this.getScrollStart();
    }

    isScrolledToEnd() {
        return this.scrollTop === this.getScrollEnd();
    }

    syncScrollbar() {
        this.scrollbarPlaceholder
            .setLength(this.contentHeight);
    }

    destroy() {
		super.destroy();
        
        if (this.isScrollable && this.isCurrent) {
            this.isCurrent = false;
            this.allowScroll = false;
            this.scrollbarPlaceholder.clear();
        }

        if (this.$filters !== undefined) {
            this.$filters.remove();
        }

        if (this.openHeader) {
            $('.header').removeClass('open-forced');
        }

		this.$element.data('fullpageSectionApi', null);
	}
}

owd.registerComponent('fullpage-section', {
	component: FullpageSection
});